import { render, staticRenderFns } from "./Rating.vue?vue&type=template&id=4d44ef00&"
import script from "./Rating.vue?vue&type=script&lang=ts&"
export * from "./Rating.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseStarRating: require('/home/vsts/work/1/a/NuxtApp/components/base/StarRating.vue').default})
